import type { ConciseWorkspace } from '@festina/configuration-general-types/configuration'
import type { WorkspaceKey } from '@festina-life/api'
import type {
  ConfigurableServer,
  NonEmptyArray,
  Optional,
} from '@festina-life/core'
import {
  addLeafToTree,
  type TreeNodeData,
} from '@festina-life/ui/listsAndTables'

import { isEqualWorkspace } from '../../../workspace/helpers'
import { conciseWorkspaceToWorkspaceKey } from '../../branchesPanel/branchDetails/branchWorkspaces/helpers'
import type { WorkspaceLeaf } from '../types'

export const generateServerTree = ({
  server,
  orphanWorkspaces,
  nonOrphanWorkspaces,
  activeWorkspaceKey,
}: {
  server: ConfigurableServer
  orphanWorkspaces: ConciseWorkspace[]
  nonOrphanWorkspaces: ConciseWorkspace[]
  activeWorkspaceKey: Optional<WorkspaceKey>
}): TreeNodeData<WorkspaceLeaf> => {
  const serverPath: NonEmptyArray<string> = [server]
  const serverTree = {
    name: server,
    tags: [],
    path: serverPath,
    isActive: false,
    leaves: orphanWorkspaces.map((workspace) =>
      toWorkspaceLeaf({ workspace, activeWorkspaceKey, server }),
    ),
    nodes: [],
  } as TreeNodeData<WorkspaceLeaf>

  nonOrphanWorkspaces.forEach((workspace) => {
    const workspaceLeaf = toWorkspaceLeaf({
      activeWorkspaceKey,
      workspace,
      server,
    })

    addLeafToTree({
      tree: [serverTree],
      leaf: workspaceLeaf,
      atPath: `${server}`,
      currentPath: [],
    })
  })

  return serverTree
}

const toWorkspaceLeaf = ({
  activeWorkspaceKey,
  workspace,
  server,
}: {
  workspace: ConciseWorkspace
  server: ConfigurableServer
  activeWorkspaceKey: Optional<WorkspaceKey>
}): WorkspaceLeaf => {
  const leafKey = conciseWorkspaceToWorkspaceKey({ workspace, server })

  return {
    id: leafKey.name,
    tags: [],
    key: leafKey,
    isActive: isEqualWorkspace(leafKey, activeWorkspaceKey),
    packageName: undefined,
  }
}
